<template>
  <div id="app">
    <router-view />
  </div>
</template>

<style media="screen">
body {
  margin: 0;
  height: 100vh;
  width: 100%;
  background: #efefef;
}
#app {
  height: 100%;
}
</style>
